import { FC } from 'react';
import { getRequestedLanguages } from '../../locale/languages';

interface BrochureConfirmModalProps {
    text: string;
    confirmLabel?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const BrochureConfirmModal: FC<BrochureConfirmModalProps> = ({ text, confirmLabel, onConfirm, onCancel }) => {
    const language = getRequestedLanguages(window.errea_accountUserData.language);

    return (
        <div className="brochureConfirmModal" onClick={onCancel}>
            <div className="brochureConfirmModal__content" onClick={(e) => e.stopPropagation()}>
                <h2>{language.modal.confirm_title}</h2>
                <p className="brochureConfirmModal__text">{text}</p>
                <div className="brochureConfirmModal__actions">
                    <span className="errea_button outline brochureConfirmModal__cancel" onClick={onCancel}>
                        <span className="text">{language.modal.cancel}</span>
                    </span>
                    <span className="errea_button solid brochureConfirmModal__confirm" onClick={onConfirm}>
                        <span className="text">{confirmLabel ?? language.modal.delete}</span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default BrochureConfirmModal;
